import { render } from "./GeneralTestingAccessPage.vue?vue&type=template&id=7082aa0c&scoped=true"
import script from "./GeneralTestingAccessPage.vue?vue&type=script&lang=js"
export * from "./GeneralTestingAccessPage.vue?vue&type=script&lang=js"

import "./GeneralTestingAccessPage.vue?vue&type=style&index=0&id=7082aa0c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7082aa0c"]])

export default __exports__